export default __webpack_public_path__ + "static/9_25-26f85aa2d11333dc958f9294737b71e1.png";